import Settings from '../../../../../settings/Settings';
import Session from '../../../session/Session';
import Enrage from '../../enrage/Enrage';

const WIDTH = 300;
const HEIGHT = 100;

const FRAMES = {
    ON: 'gui/footer/button_on',
    OFF: 'gui/footer/button_off',
};

const PRICE = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 40,
    TINT: 0xffffff,
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.5 },
};

const TITLE = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 26,
    TINT: 0x34495e,
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.0 },
};

const PUSH = {
    DURATION: 60,
    EASE: Phaser.Math.Easing.Linear,
    DIST: 3,
};

export default class Refresh extends Phaser.GameObjects.Container {
    private bg!: Phaser.GameObjects.Image;
    private icon!: Phaser.GameObjects.Image;
    private price!: Phaser.GameObjects.BitmapText;
    private title!: Phaser.GameObjects.BitmapText;
    private upgradePrice: number = 0;
    private tweenPush?: Phaser.Tweens.Tween;
    private baseY: number;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.baseY = y;

        this.setupBG();
        this.setupPrice();
        this.setupTitle();
        this.setupListeners();
    }

    static get WIDTH() {
        return WIDTH;
    }

    setupBG() {
        this.bg = this.scene.add.image(0, 0, 'atlas', FRAMES.ON);
        this.bg.setOrigin(0);
        this.add(this.bg);

        this.bg.setInteractive({ useHandCursor: true });
        this.bg.on('pointerdown', () => {
            this.emit('click');
            this.push();
        });
    }

    setupPrice() {
        let x = WIDTH / 2 - 40;
        let y = 25;

        this.icon = this.scene.add.image(x, y, 'atlas', 'gui/footer/price_coin');
        this.icon.setOrigin(0, 0.5);
        this.add(this.icon);

        x += this.icon.displayWidth + 8;
        y = 22;

        this.price = this.scene.add.bitmapText(x, y, PRICE.FONT, '0', PRICE.SIZE);
        this.price.setOrigin(0, 0.5);
        this.price.setTint(PRICE.TINT);
        // this.price.setDropShadow(PRICE.SHADOW.X, PRICE.SHADOW.Y, PRICE.SHADOW.TINT, PRICE.SHADOW.ALPHA);
        this.add(this.price);
    }

    setupTitle() {
        let x = WIDTH / 2;
        let y = 65;

        this.title = this.scene.add.bitmapText(x, y, TITLE.FONT, 'REFRESH ENRAGE', TITLE.SIZE);
        this.title.setOrigin(0.5);
        this.title.setTint(TITLE.TINT);
        // this.title.setDropShadow(TITLE.SHADOW.X, TITLE.SHADOW.Y, TITLE.SHADOW.TINT, TITLE.SHADOW.ALPHA);
        this.add(this.title);
    }

    setupListeners() {
        this.scene.events.on(Session.EVENTS.GOLD_UPDATED, this.updateAvailability, this);
        this.scene.events.on(Enrage.EVENTS.CHARGE_START, this.show, this);
        this.scene.events.on(Enrage.EVENTS.CHARGE_END, this.hide, this);
    }

    enable() {
        this.bg.setInteractive();
        this.bg.setFrame(FRAMES.ON);
    }

    disable() {
        this.bg.disableInteractive();
        this.bg.setFrame(FRAMES.OFF);
    }

    update(price: number) {
        this.price.setText(String(price));
        this.upgradePrice = price;
        if (Session.Instance.gold < this.upgradePrice) this.disable();
    }

    updateAvailability(gold: number) {
        if (gold < this.upgradePrice) {
            this.disable();
        } else {
            this.enable();
        }
    }

    setMaxedOut() {
        this.disable();
        this.scene.events.off(Session.EVENTS.GOLD_UPDATED, this.updateAvailability, this);

        this.title.setText( this.scene.cache.json.get('i18n')['maxed_out'] );

        this.icon.setVisible(false);
        this.price.setVisible(false);
    }

    show() {
        this.setVisible(true);
    }

    hide() {
        this.setVisible(false);
    }

    push() {
        this.tweenPush?.stop();
        this.y = this.baseY;

        this.tweenPush = this.scene.tweens.add({
            targets: this,
            duration: PUSH.DURATION,
            ease: PUSH.EASE,
            y: `+=${PUSH.DIST}`,
            yoyo: true,
        });
    }

    destroy() {
        this.scene.events.off(Session.EVENTS.GOLD_UPDATED, this.updateAvailability, this);
        this.scene.events.off(Enrage.EVENTS.CHARGE_START, this.show, this);
        this.scene.events.off(Enrage.EVENTS.CHARGE_END, this.hide, this);
        super.destroy();
    }
}
